<template>
  <div class="outer-wrap">
    <el-select
      class="search-input"
      v-model="searchSelectVal"
      filterable
      remote
      reserve-keyword
      placeholder="请输入关键词"
      :remote-method="querySearchAsync"
      :loading="searchLoading"
      @change="selectSearchRes"
    >
      <el-option-group v-for="group in groupList" :key="group.value" :label="group.label">
        <el-option v-for="item in group.list" :key="item.value" :label="item.label" :value="item.value">
          <div class="option-wrap">
            <div class="label-name">{{ item.label }}</div>
            <div class="conver-num">覆盖人数{{ item.fans_num }}粉丝</div>
          </div>
        </el-option>
      </el-option-group>
    </el-select>
    <div class="transfer-in-wrap">
      <div class="panel-card" style="width: 50%; flex-shrink: 0; margin-right: 16px">
        <div class="panel-header">
          <span :class="['header-item', curType === 'class' ? 'cur' : '']" @click="curType = 'class'">添加达人分类</span>
          <span :class="['header-item', curType === 'user' ? 'cur' : '']" @click="curType = 'user'">添加抖音达人</span>
        </div>
        <div class="card-content">
          <div class="panel-wrap" v-show="curType === 'class'">
            <el-cascader-panel
              ref="cascaderPanelRef"
              v-model="catagoryList"
              :props="{
                multiple: true,
                value: 'id',
                label: 'value',
                emitPath: false,
              }"
              clearable
              :options="classifyList"
              :show-all-levels="false"
              @change="selectChange"
            >
              <template slot-scope="{ data }">
                <div class="tree-node-wrap">
                  <div class="text-line" style="font-weight: bold">
                    {{ data.value }}
                  </div>
                  <div class="text-line">粉丝数量 {{ data.fans_num_str }}</div>
                </div>
              </template>
            </el-cascader-panel>
          </div>
          <div class="panel-wrap" v-show="curType === 'user'">
            <el-cascader
              v-model="userClass"
              ref="userClassifyRef"
              class="user-cascader"
              :props="{
                value: 'id',
                label: 'value',
                emitPath: false,
              }"
              :options="classifyList"
              :show-all-levels="false"
              @change="changeUserClassify"
            >
            </el-cascader>
            <div class="userList">
              <el-checkbox-group class="checked-box-group" v-model="checkedUserList" @change="changSelectUser">
                <el-checkbox :label="item.aweme_id" v-for="item of userList" :key="item.aweme_id">
                  <div class="userList-wrap">
                    <div class="user-img-wrap">
                      <img :src="item.avatar" class="user-img" />
                    </div>
                    <div class="user-text-wrap">
                      <div class="top-text">{{ item.author_name }}</div>
                      <div class="bottom-text">粉丝：{{ item.total_fans_num_str }} 分类：{{ item.category_name }}</div>
                    </div>
                    <el-button class="text-btn" @click="searchSame(item.aweme_id)" type="text">找相似</el-button>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-card">
        <div
          class="panel-header"
          style="
            display: block;
            line-height: 42px;
            text-align: right;
            padding-right: 16px;
            cursor: pointer;
            background: rgba(0, 0, 0, 0.02);
          "
        >
          <span class="clear" @click="clearData">清除</span>
        </div>
        <div class="card-content">
          <div class="content-header">
            <span class="header-col" style="cursor: pointer">全部<i class="el-icon-arrow-down" style="margin-left: 4px"></i></span>
            <span class="header-col">覆盖人数</span>
          </div>
          <ul class="select-list">
            <li class="select-item" v-for="item of nodeList" :key="item.id">
              <span class="item-name">{{ item.value }}</span>
              <span class="item-name">{{ item.cover_num_str }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { awemeAuthor, awemeSimilar, awemeSearch } from "@/api/promotion.js";
import { mapState } from "vuex";
export default {
  name: "DyTransfer",
  props: {
    classifyList: {
      type: Array,
      default: () => [],
    },
    dySelectBehaviorList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      catagoryList: [],
      selectClassList: [],
      selectUserList: [],

      curType: "class", //当前分类
      userClass: null,
      allUserList: [], //缓存所有用户
      userList: [], //option
      checkedUserList: [], //id数组
      //搜索相关
      searchLoading: false,
      groupList: [],
      searchSelectVal: null,
    };
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
    }),
    nodeList() {
      return this.selectClassList.concat(this.selectUserList);
    },
  },
  methods: {
    selectChange() {
      let data = this.$refs.cascaderPanelRef.getCheckedNodes(true);
      this.selectClassList = data.map((item) => item.data);
      this.$emit("selectChange", this.selectClassList);
    },
    clearData() {
      this.$refs.cascaderPanelRef.clearCheckedNodes();
      this.selectClassList = [];
      this.selectUserList = [];
      this.checkedUserList = [];
    },

    getSelectList() {
      return {
        userList: this.selectUserList,
        classList: this.selectClassList,
      };
    },
    // isPro 是否已有项目
    setSelectList(data) {
      this.searchSelectVal = "";
      this.catagoryList = data.dyClassList.map((item) => item.id);
      this.userClass = [];
      this.userList = [];
      this.selectUserList = data.dyUserList;
      this.selectClassList = data.dyClassList;
    },
    //远程搜索
    querySearchAsync(querystr) {
      if (querystr !== "") {
        this.searchLoading = true;
        awemeSearch({
          advertiserId: this.adCount,
          search: querystr,
          behaviors: this.dySelectBehaviorList.join(),
        }).then((res) => {
          this.searchLoading = false;
          if (res.code === "0000") {
            //处理分类数据
            let classList = [];
            res.awemeCategories.forEach((item) => {
              if (item.children) {
                item.children.forEach((child) => {
                  child.label = item.value + "/" + child.value;
                  child.value = child.id;
                  child.fans_num = item.fans_num_str;
                  classList.push(child);
                });
              } else {
                item.label = item.value;
                item.value = item.id;
                item.fans_num = item.fans_num_str;
                classList.push(item);
              }
            });

            let data = [
              { label: "相关达人分类", value: "1", list: classList },
              {
                label: "相关抖音达人",
                value: "2",
                list: res.awemeAuthor.map((item) => {
                  item.label = item.author_name;
                  item.value = item.aweme_id;
                  item.fans_num = item.total_fans_num_str;
                  return item;
                }),
              },
            ];
            this.groupList = data;
          }
        });
      }
    },
    selectSearchRes(res) {
      let allList = [];
      this.groupList.forEach((groupItem) => {
        allList = allList.concat(groupItem.list);
      });
      let curItem = allList.find((item) => item.value === res);
      if (curItem.avatar) {
        //点击了达人
        this.userList = this.groupList[1].list;
        this.allUserList = this.allUserList.concat(this.groupList[1].list);
        this.curType = "user";
        let hasSelect = this.checkedUserList.find((id) => id === res);
        if (!hasSelect) {
          this.checkedUserList.push(res);
          this.changSelectUser();
        }
      } else {
        this.curType = "class";
        // let hasSelect = this.catagoryList.find((id) => id === res);
        // if (!hasSelect) {
        //   this.catagoryList.push(res);
        //   this.selectChange();
        // }
      }
    },

    //用户相关
    changeUserClassify() {
      awemeAuthor({
        advertiserId: this.adCount,
        catagoryId: this.userClass,
        behaviors: this.dySelectBehaviorList.join(),
      }).then((res) => {
        if (res.code === "0000") {
          this.userList = res.awemeAuthor;
          this.allUserList = this.allUserList.concat(res.awemeAuthor);
        }
      });
    },
    searchSame(id) {
      awemeSimilar({
        advertiserId: this.adCount,
        awemeId: id,
        behaviors: this.dySelectBehaviorList.join(),
      }).then((res) => {
        if (res.code === "0000") {
          this.userList = res.awemeAuthor;
          this.allUserList = this.allUserList.concat(res.awemeAuthor);
        }
      });
    },
    changSelectUser() {
      let userDataList = [];
      this.checkedUserList.forEach((id) => {
        let curItem = this.allUserList.find((item) => item.aweme_id === id);
        if (curItem) {
          userDataList.push({
            id: curItem.aweme_id,
            label_id: curItem.label_id,
            value: curItem.author_name,
            cover_num_str: curItem.cover_num_str,
          });
        }
      });
      this.selectUserList = userDataList;
    },
  },
};
</script>

<style lang="less" scoped>
.outer-wrap {
  .search-input {
    width: 500px;
    margin-bottom: 12px;
  }
  .transfer-in-wrap {
    min-height: 290px;
    display: flex;
    .panel-card {
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      width: 100%;
      .panel-header {
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        .header-item {
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          border-bottom: 2px solid transparent;
          padding: 10px 0;
          cursor: pointer;
          &.cur {
            color: rgba(24, 144, 255, 1);
            border-bottom: 2px solid rgba(24, 144, 255, 1);
          }
        }
        .clear {
          color: rgba(24, 144, 255, 1);
          font-size: 14px;
          flex: right;
        }
      }
    }
    .card-content {
      height: 300px;
      .input-wrap {
        padding: 8px;
      }
      .panel-wrap {
        width: 100%;
        height: 100%;
        overflow-x: auto;
        /deep/ .el-cascader-panel.is-bordered {
          border: none;
          .el-cascader-menu__wrap {
            height: 310px;
            padding: 0px;
          }
          .el-cascader-node {
            height: 40px;
          }
        }
        .tree-node-wrap {
          line-height: 14px;
          .text-line {
            font-size: 12px;
          }
        }
        .user-cascader {
          width: 500px;
          margin: 4px 0px 4px 8px;
        }
        .userList {
          height: 246px;
          overflow: auto;

          .checked-box-group {
            /deep/ .el-checkbox {
              display: flex;
              align-items: center;
              width: 100%;
              height: 54px;
              line-height: 54px;
              padding: 0px 12px;
              box-sizing: border-box;
              .el-checkbox__label {
                display: inline-block;
                width: 100%;
              }
              &:hover {
                background-color: #eee;
              }
            }
          }

          .userList-wrap {
            height: 54px;
            display: flex;
            align-items: center;
            .user-img-wrap {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              flex-shrink: 0;
              margin-right: 12px;
              overflow: hidden;
              .user-img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            .user-text-wrap {
              width: 340px;
              .top-text {
                font-size: 14px;
                color: #333;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .bottom-text {
                font-size: 12px;
                color: #999;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            .text-btn {
              flex-shrink: 0;
              margin-left: 20px;
            }
          }
        }
      }
      .content-header {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        .header-col {
          color: rgba(0, 0, 0, 0.65);
          font-size: 13px;
        }
      }
      .select-list {
        padding: 0px 10px;
        margin: 0px;
        list-style: none;
        height: 260px;
        overflow: auto;
        .select-item {
          display: flex;
          justify-content: space-between;
          padding: 5px 0;
          .item-name {
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 120px;
          }
        }
      }
    }
  }
}
.el-select-dropdown__item {
  height: 40px;
  .option-wrap {
    height: 40px;
    .label-name {
      line-height: 16px;
      color: #333;
    }
    .conver-num {
      line-height: 16px;
      font-size: 12px;
      color: #999;
    }
  }
}
</style>
